<template>
    <tr :class="`${isDeleteRequested || isEditRequested ? 'edit-row' : ''}`">
        <td>
            <template v-if="!billAsTypeLabel">
                <EmptyTextHandler :text="payorTypeLabel" />
            </template>
            <template v-else>
                {{ billAsTypeLabel }}
                <span class="row-info badge ms-1">
                    {{ payorTypeLabel }}
                </span>
            </template>
        </td>
        <td>
            <EmptyTextHandler :text="payer.AgencyPayorName" />
            <span class="row-info badge badge-info ms-1" v-if="isUpcoming && !!payer.AgencyPayorName"> Upcoming </span>
        </td>
        <td>
            <EmptyTextHandler :text="payer.MemberId" />
        </td>
        <td v-if="!isDeleteRequested">
            <EmptyTextHandler :text="payer.GroupName" />
        </td>
        <td v-if="!isDeleteRequested">
            <EmptyTextHandler :text="payer.GroupId" />
        </td>
        <td v-if="!isDeleteRequested">
            <EmptyTextHandler :text="formatDate(payer.EffectiveDate)" />
        </td>
        <td class="text-end" v-if="!isDeleteRequested">
            <button
                type="button"
                class="btn table-btn btn-outline-info"
                @click="openEditPayer()"
                v-if="!isEditRequested"
            >
                <i class="fas fa-edit"></i>
            </button>
            <button
                type="button"
                class="btn table-btn btn-outline-danger"
                @click="confirmDeletePayer()"
                v-if="!isEditRequested"
            >
                <i class="fas fa-trash-alt"></i>
            </button>
            <i v-if="isEditRequested">Edit In Progress</i>
        </td>
        <!-- DELETE -->
        <td colspan="4" v-if="isDeleteRequested">
            <TablePrompt
                ok-text="delete"
                name="delete"
                :is-in-progress="isDeleteInProgress"
                :ok="deletePayer"
                :cancel="cancelDeletePayer"
            />
        </td>
    </tr>
    <!-- EDIT -->
    <tr v-if="isEditRequested" class="edit-row">
        <td :colspan="columns" class="p-3 edit">
            <PayerForm
                v-if="cachedData"
                :payer="cachedData"
                :patientDetails="patientDetails"
                :is-loading="isEditInProgress"
                :is-add-form="false"
                :medicare-ids="medicareIds"
                ref="payerForm"
            />
            <div class="text-center" v-if="!isEditInProgress">
                <button type="button" class="btn btn-primary btn-md" @click="updatePayer()">Save Payer</button>
                <button type="button" class="btn btn-outline-secondary btn-md ms-2" @click="closeEditPayer()">
                    Cancel
                </button>
            </div>
        </td>
    </tr>
</template>

<script lang="ts" src="./PayerRow.ts"></script>
